import React from 'react';
import { AuthContainer } from '../../components/auth/AuthContainer';
import { SignInLoginPasswordForm } from "../../components/auth/SignInLoginPasswordForm";

export const AuthPage = () => {

    return (
        <AuthContainer>
            <SignInLoginPasswordForm />
        </AuthContainer>
    )
}